interface Props {
    offer: SiteOffer;
}

export default function OfferAnalytics({ offer }: Props) {
    return <script type="text/plain" data-offer={offer.fields.name} />;
}
